// extracted by mini-css-extract-plugin
export default {"main":"ModalModificarPago_main__5u9i+","intro":"ModalModificarPago_intro__gtlNs","input":"ModalModificarPago_input__21-td"};